/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import { Link } from 'react-router-dom'
import { Flex } from '../../Layout'
import GameListTeamLogo from './GameListTeamLogo'
import Text from 'src/components/ts-components/Text'

const GameListRowTeam = ({
  team = {},
  isHome,
  teamSlot = {},
  scheduleId = null,
}) => {
  const to = team?.id
    ? `${ROUTES.TEAM_ROOT}/${team.id}${
        scheduleId ? `?sn_schedule=${scheduleId}` : ''
      }`
    : undefined
  const disableLink = !to || window.location.pathname === to

  return (
    <Flex
      noFlex
      as={disableLink ? undefined : Link}
      to={disableLink ? undefined : to}
      alignItems='center'
      flexDirection={isHome ? 'row' : 'row-reverse'}
      css={css`
        width: 25%;
        padding: 0 8px;
        ${!disableLink &&
        `
          transition: background-color 0.2s ease-in-out;
          &:hover {
            background-color: ${colors.SECONDARY_300};
            border-radius: 8px;
          }
        `}
      `}
    >
      <GameListTeamLogo team={team} />
      <div
        css={css`
          ${!isHome && 'text-align: right;'}
          ${isHome ? 'margin-left: 8px;' : 'margin-right: 8px;'}
        `}
      >
        <Text
          variant='heading5'
          weight='semiBold'
          color={colors.NEUTRAL_0}
          style={'text-transform: uppercase;'}
        >
          {team
            ? team?.name_full
            : teamSlot
            ? teamSlot?.name_full
            : isHome
            ? 'Home Team'
            : 'Visiting Team'}
        </Text>

        <Text
          variant='captionSmall'
          weight='semiBold'
          color={colors.NEUTRAL_50}
        >
          {isHome ? 'HOME' : 'VISITOR'}
        </Text>
      </div>
    </Flex>
  )
}

export default GameListRowTeam
